import React from "react";

const Single = (props: any) => {
  return (
    <svg width={13} height={10} fill="none" {...props}>
      <path stroke="var(--color-blue)" d="m1.375 4.875 3.5 3.75 7-7.5" />
    </svg>
  );
};

export default Single;
